<template>
  <div class="col-md-12 servers_list">
    <div
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
            <span
                class="mdi"
                :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
                @click="toggleFiltersState"
            />
      <span class="main_fiters_toggler_text">
              {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
            </span>
    </div>

    <div class="filters" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="form_select">
        <fg-input
            v-model="filter.q"
            type="text"
            :placeholder="translate('search')"
            :clearable="true"
            @input="change_input"
        />
      </div>

      <div class="form_select">
        <tree-select
            :options="client_list"
            :multiple="false"
            v-model="filter.client_id"
            :placeholder="translate('server.server_list.client')"
            :clearable="true"
            @input="change_input"
        />
      </div>

      <div class="form_select">
        <tree-select
            :options="server_group_list"
            :multiple="false"
            v-model="filter.server_group_id"
            :placeholder="translate('server.server_list.group')"
            :clearable="true"
            @input="change_input"
        />
      </div>

      <div class="form_select">
        <tree-select
            :options="backup_list"
            :multiple="false"
            v-model="filter.backup"
            :placeholder="translate('server.server_list.backup')"
            :clearable="true"
            @input="change_input"
        />
      </div>

      <div class="form_select">
        <tree-select
            :options="visible_list"
            :multiple="false"
            v-model="filter.visible"
            :placeholder="translate('server.server_list.visible')"
            :clearable="false"
            @input="change_input"
        />
      </div>

      <div class="form_select"></div>
    </div>

    <div class="response_table" >
      <div class="loading" v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>
      <table v-else>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th
                class="pointer text-left"
                scope="col"
                @click="change_filter('name')"
                :class="{ selected: filter_type === 'name' }"
            >
              {{ translate('server.name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer text-left"
                scope="col"
                @click="change_filter('name_short')"
                :class="{ selected: filter_type === 'name_short' }"
            >
              {{ translate('server.name_short') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th class="text-left" scope="col">
              {{ translate('server.client_name') }}
            </th>
            <th class="text-left" scope="col">
              {{ translate('server.group') }}
            </th>
            <th class="text-left" scope="col">
              {{ translate('server.place') }}
            </th>
            <th class="text-left" scope="col">
              {{ translate('server.hoster') }}
            </th>
            <th class="text-left" scope="col">
              IP
            </th>
            <th
                class="pointer"
                scope="col"
                @click="change_filter('instance_count')"
                :class="{ selected: filter_type === 'instance_count' }"
            >
              {{ translate('server.instances') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                scope="col"
                @click="change_filter('device_count')"
                :class="{ selected: filter_type === 'device_count' }"
            >
              {{ translate('server.devices') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <ServerItem
              v-for="(server,key) in server_list"
              :key="key"
              :server="server"
              :groups_servers="groups_servers"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import ServerItem from "./Item/Index.vue";

export default {
  name: 'ServerList',
  components: {
    ServerItem
  },
  props: {
    active: Boolean,
    groups_servers: Array
  },
  data () {
    return {
      active_2day: true,
      servers: [],
      loading: true,
      filter_asc: "asc",
      filter_type: "",
      filter:{
        q: "",
        server_group_id: null,
        client_id: null,
        backup: null,
        visible: 1
      },
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  created() {
    this.check_query()
    this.get_servers()
  },

  activated() {
    this.check_query()
    this.get_servers()
  },

  computed:{
    backup_list(){
      return [
        { id: 0, label: this.translate("server.server_list.only_stcp") },
        { id: 1, label: this.translate("server.server_list.only_backup") },
        { id: -1, label: this.translate("server.server_list.all") }
      ]
    },
    server_list(){
      return this.servers.sort(this.compareNumbers);
    },
    visible_list(){
      return [
        { id: "", label: this.translate("server.server_list.visible_all") },
        { id: 0, label: this.translate("server.server_list.visible_off") },
        { id: 1, label: this.translate("server.server_list.visible_on") }
      ]
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return { id: client.id, label: client.name }
      })
    },
    server_group_list(){
      return this.groups_servers.map((client) => {
        return { id: client.id, label: client.name }
      })
    },
    send_filter(){
      let filter = {}
      Object.keys(this.filter).forEach((item) => {
        this.filter[item] !== null && this.filter[item] !== "" && this.filter[item] !== undefined ? filter[item] = this.filter[item] : ""
      })
      return filter
    }
  },

  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'servers_section') {
          let string = '?'

          for (let key in this.filter) {
            if (key === 'client_id' && this.filter[key]) {
              string += '&' + key + '=' + this.filter[key]
            }
          }
          history.pushState(null, null, this.$route.path + string)
        }
      }
    },
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_servers, 500)
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'client_id':
              this.filter.client_id = this.$route.query[key]
              break;
          }
        }
      }
    },
    get_servers(){
      this.loading = true
      this.$http.v1.getServers(this.send_filter, (response) => {
        this.servers = response.data ? response.data.sort((a, b) => { return b['device_count'] - a['device_count'] }) : []
        this.loading = false
      })
    },
    go_to() {
      return { path: '/server/' + this.client_order.id }
    },
    update (val) {
      this.$http.v1.updateMainServer(val, () => {
        this.global_notify('info', this.translate('server.profile_save'))
        this.$emit('update_servers_list')
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang="scss" scoped>
  .servers_list{
    height: 100%;
    padding-top: 30px;
    display: flex;
    flex-direction: column;

    .filters{
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex: 1;

      .form_select{
        flex: 1;
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
        .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }

    .loading {
      background-color: #fff;
      height: calc(100% - 80px);
      width: calc(100% - 30px);
    }

    .response_table{
      flex: 10;
      padding: 0 0 1px;
      th{
        font-size: 12px;
        &.text-left{
          text-align: left;
        }
      }
    }
  }

</style>
